import { Fragment, useState } from 'react';
import AlertSnip from '../../assets/code-snippets/alert/snip'

const Alert = () => {

    const [alert, setAlert] = useState({
        cls: 'top anime-top',
        active: false
    })
    const helper = (e) => {
        setAlert({
            cls: e,
            active: true
        })
    }
    const toggle = () => {
        setAlert(prev => ({ ...prev, active: !prev.active }))
    }

    return <Fragment>

        <AlertSnip {...alert} toggle={toggle} />

        <div className="container fluid p-3">
            <div className="container xl text-md text-center">
                <p className="text xxl primary">Alert implementation</p>
                <p className="text md">Implementation of alerts is made using pure HTML and CSS, JS is added only for toggling the '<code>active</code>' class to this. Clicking the buttons below will make this alerts to pop up in which its specific the source code can be found.</p>
            </div>

            <div className="container fluid">
                <div className="row justify-content-center gap-10">
                    <div className="col md-I">
                        <div className="form-item lg">
                            <button className='btn lg primary outline wide' onClick={toggle}>Toggle alert</button>
                        </div>
                        <div className="form-item lg">
                            <label>Alerts fixed to the top</label>
                            <select onClick={(e) => helper(e.target.value)}>
                                <option value="top anime-top">.top.anime-top</option>
                                <option value="top anime-fade">.top.anime-fade</option>
                                <option value="top anime-swing">.top.anime-swing</option>
                            </select>
                        </div>
                        <div className="form-item lg">
                            <label>Alerts to the corners</label>
                            <select onClick={(e) => helper(e.target.value)}>
                                <option value="left-top">.left-top</option>
                                <option value="left-bottom">.left-bottom</option>
                                <option value="right-top">.right-top</option>
                                <option value="right-bottom">.right-bottom</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </Fragment>

}

export default Alert